import React from 'react';
import { Helix2000Character } from '../../../../../shared/CharacterTypes';
import { sectionHeaderStyle } from './styles';
import { useWithLiveVitals } from '../../../hooks/usePlayerVital';

interface PlayerStatsProps {
  player: Helix2000Character;
}

export const PlayerStats: React.FC<PlayerStatsProps> = ({ player: reactPlayer }) => {
  // HP/MP from the vitals store, not the React player (plan 21 §8.3).
  const player = useWithLiveVitals(reactPlayer);
  return (
    <>
      <div style={sectionHeaderStyle}>Live Stats</div>
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '11px', marginBottom: '15px' }}>
        <thead>
          <tr style={{ borderBottom: '1px solid rgba(255,255,255,0.1)' }}>
            <th style={{ textAlign: 'left', padding: '4px', color: '#888' }}>Stat</th>
            <th style={{ textAlign: 'right', padding: '4px', color: '#888' }}>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr><td style={{ padding: '3px', color: '#aaa' }}>Level</td><td style={{ textAlign: 'right', color: '#ffd700' }}>{player.level}</td></tr>
          <tr><td style={{ padding: '3px', color: '#aaa' }}>XP</td><td style={{ textAlign: 'right', color: '#3498db' }}>{player.xp} / {(player.level || 1) * 100}</td></tr>
          <tr><td style={{ padding: '3px', color: '#aaa' }}>Stat Points</td><td style={{ textAlign: 'right', color: (player.statPoints || 0) > 0 ? '#2ecc71' : '#666' }}>{player.statPoints || 0}</td></tr>
          <tr style={{ borderTop: '1px solid rgba(255,255,255,0.05)' }}><td style={{ padding: '3px', color: '#f87171' }}>STR</td><td style={{ textAlign: 'right' }}>{player.stats?.strength || 0}</td></tr>
          <tr><td style={{ padding: '3px', color: '#4ade80' }}>DEX</td><td style={{ textAlign: 'right' }}>{player.stats?.dexterity || 0}</td></tr>
          <tr><td style={{ padding: '3px', color: '#60a5fa' }}>INT</td><td style={{ textAlign: 'right' }}>{player.stats?.intelligence || 0}</td></tr>
          <tr><td style={{ padding: '3px', color: '#facc15' }}>LUK</td><td style={{ textAlign: 'right' }}>{player.stats?.luck || 0}</td></tr>
          <tr style={{ borderTop: '1px solid rgba(255,255,255,0.05)' }}><td style={{ padding: '3px', color: '#888' }}>ATK</td><td style={{ textAlign: 'right' }}>{player.stats?.attack || 0}</td></tr>
          <tr><td style={{ padding: '3px', color: '#888' }}>MATK</td><td style={{ textAlign: 'right' }}>{player.stats?.magicAttack || 0}</td></tr>
          <tr><td style={{ padding: '3px', color: '#888' }}>DEF</td><td style={{ textAlign: 'right' }}>{player.stats?.defense || 0}</td></tr>
          <tr><td style={{ padding: '3px', color: '#888' }}>MDEF</td><td style={{ textAlign: 'right' }}>{player.stats?.magicDefense || 0}</td></tr>
          <tr style={{ borderTop: '1px solid rgba(255,255,255,0.05)' }}><td style={{ padding: '3px', color: '#e74c3c' }}>HP</td><td style={{ textAlign: 'right' }}>{Math.round(player.health)} / {Math.round(player.maxHealth)}</td></tr>
          <tr><td style={{ padding: '3px', color: '#3498db' }}>MP</td><td style={{ textAlign: 'right' }}>{Math.round(player.mana)} / {Math.round(player.maxMana)}</td></tr>
        </tbody>
      </table>
    </>
  );
};
